"use client"
import { useEffect, useRef, useState } from 'react'

export const ChooseYourPathArrowLabel = ({
  label,
  labelClassName,
  width,
  labelWidthPct,
  hFrac,
  vFrac,
  textAlign,
}: {
  label: string
  labelClassName: string
  width: number
  labelWidthPct?: number
  hFrac: number
  vFrac: number
  textAlign: 'left' | 'right' | 'center'
}) => {
  const ref = useRef<HTMLDivElement>(null)
  const [isMultiLine, setIsMultiLine] = useState(() => label.includes('\n'))

  useEffect(() => {
    const el = ref.current
    if (!el) return
    const measure = () => {
      const lineHeight = parseFloat(getComputedStyle(el).lineHeight)
      if (!Number.isFinite(lineHeight) || lineHeight <= 0) return
      setIsMultiLine(el.scrollHeight > lineHeight * 1.25)
    }
    measure()
    const observer = new ResizeObserver(measure)
    observer.observe(el)
    return () => observer.disconnect()
  }, [label, width, labelWidthPct])

  return (
    <div
      ref={ref}
      className={`${labelClassName} text-current`}
      style={{
        width: labelWidthPct != null ? (labelWidthPct / 100) * width : 'max-content',
        transform: `translate(${-hFrac * 100}%, ${-vFrac * 100}%)`,
        textAlign,
        opacity: 0.7,
        whiteSpace: 'pre-wrap',
        WebkitTextStroke: '3px #fffff8',
        paintOrder: 'stroke fill',
        lineHeight: 1.3,
      }}
    >
      {label}
    </div>
  )
}
